import React, { useState } from "react";
import Layout from "../../../components/layout/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function AddProductCategory() {
  const [formData, setFormData] = useState({
    name: "",
    title: "",
    description: "",
    image: "",
    gst: 0,
    deliveryCharge: 0,
    emergencyCharge: 0,
    notes: ""
  });

  const [disableBtn, setDisableBtn] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === "image") {
      setFormData({ ...formData, image: e.target.files[0] });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      console.log(formData);
      const formdata = new FormData();
      formdata.append("name", formData.name);
      formdata.append("title", formData.title);
      formdata.append("description", formData.description);
      formdata.append("image", formData.image);
      formdata.append("gst", formData.gst);
      formdata.append("deliveryCharge", formData.deliveryCharge);
      formdata.append("emergencyCharge", formData.emergencyCharge);
      formdata.append("notes", formData.notes);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/category/create-category`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        navigate(-1);
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to add category. Please try again.", error);
    }
    setDisableBtn(false);
  };

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Add Category</h2>
            </div>
            <div className="mt-10" onSubmit={handleSubmit}>
              <form action="">

                <div className="flex gap-4 mt-4">
                  {/* Category Name */}
                  <div className="w-1/2">
                    <label htmlFor="name" className="text-sm">
                      Category Name
                    </label>
                    <br />
                    <input
                      type="text"
                      id="name"
                      className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm outline-none text-sm capitalize"
                      placeholder="Write Category Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Category Title */}
                  <div className="w-1/2">
                    <label htmlFor="title" className="text-sm">
                      Category Title
                    </label>
                    <br />
                    <input
                      type="text"
                      id="title"
                      className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm outline-none text-sm capitalize"
                      placeholder="Write Category Title"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Category Description
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Write Category Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="flex gap-4 mt-4">
                  {/* GST */}
                  <div className="w-1/3">
                    <label htmlFor="gst" className="text-sm">
                      GST (in %)
                    </label>
                    <br />
                    <input
                      type="number"
                      id="gst"
                      className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm outline-none text-sm capitalize"
                      placeholder="0"
                      name="gst"
                      value={formData.gst}
                      onChange={handleInputChange}
                      min={0}
                    />
                  </div>

                  {/* Delivery Charge */}
                  <div className="w-1/3">
                    <label htmlFor="deliveryCharge" className="text-sm">
                      Delivery Charge
                    </label>
                    <br />
                    <input
                      type="number"
                      id="deliveryCharge"
                      className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm outline-none text-sm capitalize"
                      placeholder="0"
                      name="deliveryCharge"
                      value={formData.deliveryCharge}
                      onChange={handleInputChange}
                      min={0}
                    />
                  </div>

                  <div className="w-1/3">
                    <label htmlFor="emergencyCharge" className="text-sm">
                      Emergency Charge
                    </label>
                    <br />
                    <input
                      type="number"
                      id="emergencyCharge"
                      className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm outline-none text-sm capitalize"
                      placeholder="0"
                      name="emergencyCharge"
                      value={formData.emergencyCharge}
                      onChange={handleInputChange}
                      min={0}
                    />
                  </div>

                </div>


                <div className="mt-4">

                  <label htmlFor="" className="text-sm">
                    Notes
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Notes"
                    name="notes"
                    value={formData.notes}
                    onChange={handleInputChange}
                  />

                </div>

                <div className="mt-4">
                  <label htmlFor="categoryImage" className="text-sm">
                    Category Image
                  </label>{" "}
                  <br />
                  <input
                    type="file"
                    className="block w-full text-sm text-slate-800 file:mr-4 file:px-6 file:py-2 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-slate-100 file:text-[#ff4141] cursor-pointer mt-2"
                    placeholder="Choose Picture"
                    name="image"
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-plus"></i> {disableBtn ? "Adding ..." : "Add Category"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
